import React from "react";
import { Image } from "../../../../components/Image/Image";

type CollectionProps = {
  image: string;
  onClick: () => void;
};

export const Collection = ({ image, onClick }: CollectionProps) => {
  return (
    <div
      onClick={onClick}
      className="bg-[var(--collection-bg-color)] min-h-[var(--collection-size)] min-w-[var(--collection-size)] w-[var(--collection-size)] h-[var(--collection-size)]"
    >
      <Image src={image} alt="collection" className="w-full h-full object-cover" />
    </div>
  );
};
